/* ============================================================
   bbv-search-filter.js — Bimbivip
   SOSTITUISCE bbv-search-fields.js (che va rimosso dal tema)
   ------------------------------------------------------------
   IL PROBLEMA
   La ricerca del negozio indicizza anche la descrizione prodotto
   e applica lo stemming italiano: "cinture" restituisce ~840
   risultati perché centinaia di descrizioni dicono "con cintura
   in vita", "cinturino", "cintura in stoffa".

   L'APPROCCIO PRECEDENTE (abbandonato)
   Riscrivere la query in sintassi campo:valore funzionava, ma
   la query tecnica finiva nell'URL, nel titolo e nella barra di
   ricerca, e ripulirla via JavaScript costava troppo.

   QUESTO APPROCCIO
   La query resta quella digitata dall'utente. Se il termine è
   una categoria, aggiungiamo il FILTRO NATIVO di Shopify:

       /search?q=pantaloni&type=product&filter.p.product_type=PANTALONI

   Risultato: titolo, URL e barra di ricerca restano puliti, i
   risultati sono solo pantaloni, e l'utente vede il chip del
   filtro che può togliere con un clic per vedere tutto.
   Nessuna patch cosmetica, nessun costo di performance.

   REQUISITO
   Il filtro "Categoria" (product_type) deve essere attivo anche
   sulla pagina dei risultati di ricerca:
   App > Search & Discovery > Filtri.
   Se non lo è, il parametro viene semplicemente ignorato: non
   rompe nulla, ma non filtra.

   INSTALLAZIONE
   assets/bbv-search-filter.js, poi in layout/theme.liquid
   prima di </body> (qui il defer va benissimo):

       <script src="{{ 'bbv-search-filter.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  var MIN_LEN = 3;

  // Valori reali del campo "Tipo di prodotto" (rilevati dal fronte).
  var TIPI = [
    'ABITI', 'CAMICIE', 'CAMICIE DA NOTTE', 'CANOTTE', 'CARDIGAN', 'MAGLIE',
    'POLO', 'T-SHIRT', 'T-SHIRT MANICA CORTA', 'T-SHIRT MANICA LUNGA',
    'TOP', 'FELPE', 'GILET', 'SMANICATI',
    'CAPPOTTI', 'GIACCHE', 'GIUBBINI', 'GIUBBINI JEANS', 'GIUBBINI LEGGERI',
    'PIUMINI', 'TRENCH',
    'BERMUDA', 'JEANS', 'LEGGINGS', 'PANTALONI', 'SHORTS', 'GONNE',
    'PAGLIACCETTI', 'SALOPETTE',
    'COMPLETI', 'COMPLETI ELEGANTI', 'COMPLETI SPORTIVI', 'SOTTOTUTA',
    'TUTE', 'TUTINE', 'TUTONE', 'BODY',
    'SLIP', 'BOXER', 'COULOTTE', 'REGGISENI', 'PIGIAMI', 'COSTUMI',
    'BALLERINE', 'CIABATTE', 'MOCASSINI', 'SABOT', 'SANDALI', 'SCARPETTE',
    'SNEAKERS', 'STIVALETTI', 'STIVALI',
    'SACCO NANNA', 'SACCO NEONATO', 'BAVAGLINI', 'LENZUOLINI', 'COPERTE',
    'FASCIATOI', 'ACCAPPATOI', 'TELI BAGNO', 'TELO MARE',
    'ACCESSORI', 'ASTUCCI', 'BORSE', 'BORSE NASCITA', 'BORSELLI', 'BORSONI',
    'CALZINI', 'CAPPELLI', 'CERCHIETTI', 'CINTURE', 'FASCE', 'FASCIA CAPELLI',
    'FIOCCHI', 'GIOCATTOLI', 'GIOCATTOLO', 'GUANTI', 'MARSUPI', 'PAPILLON',
    'PASHMINA', 'POCHETTE', 'SCALDACOLLO', 'SCIARPE', 'SET REGALO',
    'TRACOLLE', 'TROLLEY', 'ZAINI'
  ];

  var CALZATURE = ['BALLERINE', 'CIABATTE', 'MOCASSINI', 'SABOT', 'SANDALI',
                   'SCARPETTE', 'SNEAKERS', 'STIVALETTI', 'STIVALI'];
  var TSHIRT    = ['T-SHIRT', 'T-SHIRT MANICA CORTA', 'T-SHIRT MANICA LUNGA'];
  var GIUBBOTTI = ['GIUBBINI', 'GIUBBINI LEGGERI', 'GIUBBINI JEANS', 'PIUMINI'];

  // solo per i termini che non assomigliano al nome del tipo
  var SINONIMI = {
    'vestito': 'ABITI', 'vestiti': 'ABITI', 'vestitino': 'ABITI', 'dress': 'ABITI',
    'scarpe': CALZATURE, 'scarpa': CALZATURE, 'calzature': CALZATURE, 'shoes': CALZATURE,
    'stivale': ['STIVALI', 'STIVALETTI'],
    'giubbotto': GIUBBOTTI, 'giubbotti': GIUBBOTTI, 'giubbino': GIUBBOTTI,
    'piumino': 'PIUMINI', 'cappotto': 'CAPPOTTI',
    'maglietta': TSHIRT, 'magliette': TSHIRT, 'tshirt': TSHIRT, 't-shirt': TSHIRT,
    'maglione': ['MAGLIE', 'CARDIGAN'],
    'intimo': ['SLIP', 'BOXER', 'COULOTTE', 'REGGISENI'],
    'mutande': ['SLIP', 'BOXER', 'COULOTTE'],
    'costume': 'COSTUMI', 'pigiama': 'PIGIAMI', 'zaino': 'ZAINI',
    'borsa': 'BORSE', 'cappello': 'CAPPELLI', 'calzino': 'CALZINI',
    'sciarpa': 'SCIARPE', 'guanto': 'GUANTI',
    'tuta': ['TUTE', 'TUTINE', 'TUTONE'],
    'belt': 'CINTURE', 'belts': 'CINTURE', 'backpack': 'ZAINI'
  };

  var STOPWORDS = ['con', 'per', 'del', 'della', 'dei', 'delle', 'da', 'di',
                   'il', 'lo', 'la', 'le', 'gli', 'un', 'una', 'in', 'and'];

  // taglia la vocale finale: singolare e plurale sulla stessa radice
  function radice(parola) {
    var w = String(parola).toLowerCase().replace(/[^\wàèéìòóùç\- ]/gi, '');
    if (w.length <= MIN_LEN) return w;
    if (/[aeio]$/i.test(w)) w = w.slice(0, -1);
    return w;
  }

  var ESATTO = {}, PREFISSO = {};
  TIPI.forEach(function (t) {
    var re = radice(t), rp = radice(t.split(' ')[0]);
    (ESATTO[re] = ESATTO[re] || []).indexOf(t) === -1 && ESATTO[re].push(t);
    (PREFISSO[rp] = PREFISSO[rp] || []).indexOf(t) === -1 && PREFISSO[rp].push(t);
  });

  // termine digitato -> array di product_type, oppure null
  function tipiPerTesto(testo) {
    var parole = String(testo).trim().toLowerCase().split(/\s+/).filter(Boolean);
    var significative = parole.filter(function (p) { return STOPWORDS.indexOf(p) === -1; });
    if (significative.length !== 1) return null;   // solo ricerche di una parola

    var p = significative[0];
    if (SINONIMI[p]) return [].concat(SINONIMI[p]);

    var r = radice(p);
    if (r.length < MIN_LEN) return null;
    return ESATTO[r] || PREFISSO[r] || null;
  }

  // --- AL SUBMIT: aggiunge il filtro, non tocca la query ---------------

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/search') === -1) return;

    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;

    // ripulisce eventuali filtri aggiunti a una ricerca precedente
    Array.prototype.forEach.call(
      form.querySelectorAll('input[data-bbv-filter]'),
      function (el) { el.parentNode.removeChild(el); }
    );

    var tipi = tipiPerTesto(input.value);
    if (!tipi || !tipi.length) return;

    tipi.forEach(function (t) {
      var el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'filter.p.product_type';
      el.value = t;
      el.setAttribute('data-bbv-filter', '1');
      form.appendChild(el);
    });
  }, true);
})();